(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-discovery"] && !Shopify.designMode) return;
  try {
    (function () {
    var buttons = document.querySelectorAll('.kl-card__wishlist');
    if (!buttons.length) return;

    var storageKey = 'kl:wishlist';
    var wishlist;
    try {
      wishlist = JSON.parse(localStorage.getItem(storageKey) || '[]');
    } catch (_) {
      wishlist = [];
    }

    function persist() {
      try { localStorage.setItem(storageKey, JSON.stringify(wishlist)); } catch (_) {}
    }

    buttons.forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      if (wishlist.indexOf(handle) !== -1) {
        btn.setAttribute('aria-pressed', 'true');
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var pressed = btn.getAttribute('aria-pressed') === 'true';
        var next = !pressed;
        btn.setAttribute('aria-pressed', String(next));

        var idx = wishlist.indexOf(handle);
        if (next && idx === -1) wishlist.push(handle);
        if (!next && idx !== -1) wishlist.splice(idx, 1);
        persist();

        document.dispatchEvent(new CustomEvent('kl:wishlist:toggle', {
          detail: { handle: handle, added: next }
        }));
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
